const shoppingList = (state = {}, data) => {
    switch (data.type) {
        case 'UPDATE_SELECTED_LIST':
            return {
                ...state,
                selectedList: data.selectedList,
            };
        case 'UPDATE_SHOPPING_LISTS':
            return {
                ...state,
                lists: data.lists,
                selectedList: data.selectedList,
            };
        case 'UPDATE_LIST_NO_ITEMS':
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [data.list]: {
                        ...state.lists[data.list],
                        noOfItems: state.lists[data.list].noOfItems + data.delta,
                    },
                },
            };
        case 'TOGGLE_LIST_DELETE_CONFIRMATION':
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [data.list]: {
                        ...state.lists[data.list],
                        showDeleteConfirmation: data.value,
                    },
                },
            };
        case 'TOGGLE_LIST_EDIT':
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [data.list]: {
                        ...state.lists[data.list],
                        showEdit: data.value,
                    },
                },
            };
        case 'EDIT_LIST_NAME': {
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [data.list]: {
                        ...state.lists[data.list],
                        name: data.value,
                    },
                },
            };
        }
        case 'UPDATE_NEW_SHOPPING_LIST_ERROR':
            return {
                ...state,
                newlist: {
                    ...state.newlist,
                    error: data.error,
                },
            };
        case 'SET_SHOPPING_LIST_VIEW':
            return {
                ...state,
                shoppingListView: data.value,
            };
        default:
            return state;
    }
};

export default shoppingList;
